const API_BASE = import.meta.env.VITE_API_BASE
  || import.meta.env.VITE_API_BASE_URL
  || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev'

async function parseError(response) {
  const text = await response.text()

  if (!text) {
    return `Procurement API error: ${response.status}`
  }

  try {
    const payload = JSON.parse(text)
    return payload.error || `Procurement API error: ${response.status}`
  } catch (error) {
    return text
  }
}

export async function fetchScopeAliasReview(responseId) {
  const normalizedResponseId = String(responseId || '').trim()
  if (!normalizedResponseId) {
    throw new Error('response_id is required')
  }

  const response = await fetch(
    `${API_BASE}/procurement/bids/responses/${encodeURIComponent(normalizedResponseId)}/scope-alias-review`
  )

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function fetchScopeFirstReview(scopeId = '') {
  const normalizedScopeId = String(scopeId || '').trim()
  const url = new URL(`${API_BASE}/procurement/bids/scope-review`)

  if (normalizedScopeId) {
    url.searchParams.set('scope_id', normalizedScopeId)
  }

  const response = await fetch(url.toString())

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function fetchPackageReview(packageId = '') {
  const normalizedPackageId = String(packageId || '').trim()
  const url = new URL(`${API_BASE}/procurement/bids/package-review`)

  if (normalizedPackageId) {
    url.searchParams.set('package_id', normalizedPackageId)
  }

  const response = await fetch(url.toString())

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function createBidPackage(payload) {
  const response = await fetch(`${API_BASE}/procurement/bids/packages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function updateBidPackage(packageId, payload) {
  const normalizedPackageId = String(packageId || '').trim()
  if (!normalizedPackageId) {
    throw new Error('package_id is required')
  }

  const response = await fetch(
    `${API_BASE}/procurement/bids/packages/${encodeURIComponent(normalizedPackageId)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload || {})
    }
  )

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function submitScopeAliasReviewActions(responseId, payload) {
  const normalizedResponseId = String(responseId || '').trim()
  if (!normalizedResponseId) {
    throw new Error('response_id is required')
  }

  const response = await fetch(
    `${API_BASE}/procurement/bids/responses/${encodeURIComponent(normalizedResponseId)}/scope-alias-review`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload || {})
    }
  )

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}
